import { Box, Dialog, Divider, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import Cropper, { Area } from "react-easy-crop";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../../../../components/common/BriaButton/BriaButton";
import BriaButtonGroup from "../../../../../../../components/common/BriaButtonGroup/BriaButtonGroup";
import BriaSlider from "../../../../../../../components/common/BriaSlider/BriaSlider";
import styles from "./AdjustFramePopup.module.scss";

type Props = {
	imageUrl: string;
	open: boolean;
	onClose?: () => void;
};

const AdjustFramePopup = ({ imageUrl, open, onClose }: Props) => {
	const { t } = useTranslation("translation", { keyPrefix: "videoEditing.config.inputFrames.adjustFramePopup" });
	const [crop, setCrop] = useState({ x: 0, y: 0 });
	const [zoom, setZoom] = useState(1);

	const onCropComplete = (croppedArea: Area, croppedAreaPixels: Area) => {
		console.log(croppedArea, croppedAreaPixels);
	};

	return (
		<>
			<Dialog PaperProps={{ className: styles.paper }} open={open} onClose={onClose}>
				<Typography className={styles.title}>{t("title")}</Typography>
				<Typography className={styles.description}>{t("description")}</Typography>
				<Box className={styles.cropContainer}>
					<Cropper
						image={imageUrl}
						crop={crop}
						zoom={zoom}
						aspect={16 / 9}
						onCropChange={setCrop}
						onCropComplete={onCropComplete}
						onZoomChange={setZoom}
						showGrid={true}
						zoomWithScroll={true}
						restrictPosition={false}
						classes={{
							cropAreaClassName: styles.cropArea,
						}}
					/>
				</Box>
				<Box className={styles.controls}>
					<Box className={styles.sliderContainer}>
						<Typography className={styles.sliderLabel}>{t("slider")}</Typography>
						<BriaSlider className={styles.slider} />
					</Box>
					<Divider className={styles.divider} orientation="vertical" flexItem />
					<BriaButtonGroup>
						<BriaButton className={styles.cropBtn} buttonType="textSmall">
							{t("cropBtn")}
						</BriaButton>
						<BriaButton className={styles.expandBtn} buttonType="primaryMedium">
							{t("expandBtn")}
						</BriaButton>
					</BriaButtonGroup>
				</Box>
			</Dialog>
		</>
	);
};

export default observer(AdjustFramePopup);
